import { AplicacionModel } from "./aplicacionModel";
import { AplicacionUserPKModel } from "./aplicacionUserPKModel";

export class AplicacionUserModel {

    estado: string;
    //appUsuarioPK: AplicacionUserPKModel;
    cedula: string;
    appId: string;
    fechBaja: string;
    fechCrea: string;
    nombre: string;
    regProc: string;
    empleado: string;
    seAplicacion: AplicacionModel;

    constructor() { }
}
